
    import './styles.scoped.css';
    export default {
  "header-label": "awsui_header-label_4mvj3_170ry_5"
};
  